module.exports = __webpack_public_path__ + "img/sport7_hover.4dc84e50.png";